<template> 
    <v-dialog v-model="show" max-width="400" overlay-color="#000" overlay-opacity="0.8">
        <v-card class="px-2 pb-1">
            <v-card-title class="mb-2">
                <v-icon color="primary" class="me-2">mdi-book-plus-outline</v-icon>
                الانضمام إلى الدورة
            </v-card-title>
            <v-card-subtitle>بعد الانضمام ستظهر الدورة في صفحة دوراتي</v-card-subtitle>
            <v-card-text class="strong-text--text mt-3">تأكيد الانضمام إلى <b>{{course.name}}</b>؟</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text @click="show = false">إلغاء</v-btn>
                <v-btn color="secondary" :loading="loading" depressed class="px-4" @click="join">تأكيد الانضمام</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        value: {},
        course: {},
    },
    data(){
        return {
            show: false,
            loading: false,
        }
    },
    computed: {
        ...GlobalComputed,

    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        ...GlobalMethods,
        
        join(){
            if (!this.loading){
                this.loading = true;
                const id = this.course.id;
                this.$store.dispatch('joinCourse', {id}).then(()=>{
                    this.loading = false;
                    this.showMsg('تم الانضمام إلى الدورة بنجاح', 'success');
                    
                    this.closeAndNavigate();
                    if (this.$route.name !== 'course'){
                        this.$router.push({name: 'course', params: {id}})
                    }else{
                        this.$emit('joined');
                    }
                }).catch(err=>{
                    this.loading = false;

                    if (err && err.response && err.response.data){
                        const msg = err.response.data,
                            status = err.response.status;
                        if (msg === 'LIMIT_EXCEEDED'){
                            this.showMsg('لقد اكتمل عدد الطلاب المسموح به للدورة', 'error');
                        }else if (msg === 'ALREADY_JOINED'){
                            this.showMsg('لقد انضممت بالفعل سابقاً', 'error');
                            this.closeAndNavigate();
                        }else{
                            this.showMsg('حدثت مشكلة أثناء الانضمام', 'error');
                        }
                    }else{
                        this.showMsg('حدثت مشكلة أثناء الانضمام', 'error');
                    }
                })
            }
        },
        closeAndNavigate(){
            this.show = false;
            if (this.$route.name !== 'course'){
                this.$router.push({name: 'course', params: {id: this.course.id}})
            }
        }
    }
}
</script>

<style>

</style>